<div class="heading">
    <p>Change Status</p>
</div>
<div class="container mb-20">
    <label for="role" style="color: #5E5E72; font-size: 14px; font-weight: 700; display: inline-block;"
        class="mb-4">Status <span class="required">*</span></label>
    <div class="select-container">
        <select id="role" class="dropdown w-100" [(ngModel)]="selectedStatus" placeholder="Select Status" required #statusRef="ngModel">
            <option value="" disabled selected>Select status</option>
            <option *ngFor="let status of statusList" [value]="status.item_text">{{status?.item_text}}</option>
        </select>
        <div *ngIf="formSubmitted && statusRef.invalid" style="color: red;">Please Select a status</div>
    </div>
</div>

<div class="btn-container">
    <app-button [type]="'secondary'" [buttonType]="'button'" [buttonText]="'Cancel'" class="mr-12" (click)="close()"></app-button>
    <app-button [type]="'primary'" [buttonType]="'button'" [buttonText]="'Submit'" (click)="submit()"></app-button>
</div>